export default __webpack_public_path__ + "static/media/premium_male@3x.86fb64ce.png";